import RestClient from '../../common/modules/rest';
import { API } from '../../common/settings';

const rest = new RestClient();
const postcodeAnywhereLookupEndpoint = API.API_ENDPOINTS.POSTCODE_ANYWHERE_LOOKUP;

export const fetchAddresses = (postcode, buildingNumber) =>
  rest.get(
    `${postcodeAnywhereLookupEndpoint}/search?BuildingNameNumber=${
      buildingNumber ? encodeURIComponent(buildingNumber) : ''
    }&Postcode=${postcode}`,
  );
